import { useEffect } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { useAuth } from '@context/AuthContext';
import { AccountMenu } from '@components/account';
import PageHeader from '@components/common/Header/PageHeader';
import { HideTablet } from '@components/styles/CommonStyles';

const AccountPagesLayout = ({
    activeMenu,
    menuItemCount,
    noBorderHeader,
    productCount,
    route,
    showCartButton,
    title,
    children,
}) => {
    const { currentUser } = useAuth();
    const router = useRouter();

    useEffect(() => {
        if (!currentUser) {
            router.push('/login');
        }
    }, []);

    return (
        <PageWrapper productCount={productCount}>
            <PageHeader
                productCount={productCount}
                showCartButton={showCartButton}
                route={route || '/account'}
                title={title}
                noBorderHeader={noBorderHeader}
            />
            <HideTablet>
                <AccountMenu
                    activeMenu={activeMenu}
                    alignBottom
                    fixed
                    hideTitleWrapper
                    menuItemCount={menuItemCount}
                />
            </HideTablet>
            <ChildrenWrapper>{children}</ChildrenWrapper>
        </PageWrapper>
    );
};

export const PageWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 10vw 2fr;
    gap: 5.27vw;
  margin-top: 160px;
    margin-bottom: 40px;
    padding: 0 45px;
    justify-content: center;
    align-items: ${({ alignItems }) => alignItems || 'unset'};

    table {
        table-layout: fixed;
        td {
            word-break: break-word;
        }
    }

    @media (max-width: 1024px) {
        min-height: 100vh;
        grid-template-columns: 1fr;
        gap: 0;
        padding: 0;
        margin-top: ${({ productCount }) => (productCount ? '105px' : '83px')};
        background-color: ${({ theme }) => theme.colors.secondary};
    }
`;
const ChildrenWrapper = styled.div`
    margin-top: -12px;
    max-width: 1080px;
    min-height: 100vh;

    @media (max-width: 1024px) {
        margin-top: 0;
        max-width: 100%;
    }
`;

export default AccountPagesLayout;
